import { USER_FLOW_REQUEST } from "./constants";

export const getUserFlow = () => {
  return {
    type: USER_FLOW_REQUEST,
  };
};
